<script lang="ts">
  import { ActionType, useDispatch } from './Store';

  const dispatch = useDispatch();

  let wasSend: boolean = false;
  let success: boolean | undefined;

  let name: string;
  let email: string;
  let error: string;

  let noEmailAlert: boolean = false;

  $: canSend = email?.length > 0;

  const request = async () => {
    const body = {
      email: email || '',
      name: name || '',
      subject: 'Schichteffekt',
    };

    const response = await fetch('https://mailservice-prod.equeo.de/rest/v1/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });

    const json = await response.json();

    if (response?.status === 200 && json?.success === true) success = true;
    else {
      success = false;
      error = response?.status + ' ' + response?.statusText + ' ' + JSON.stringify(json?.errors);
    }
  };

  const handleClose = () => dispatch({ type: ActionType.toggleContact });

  const handleSend = () => {
    if (canSend) {
      wasSend = true;
      request();
    } else noEmailAlert = true;
  };
</script>

<div class="modal" id="contactModal" tabindex="-1" role="">
  <div class="modal-dialog modal-login" role="document">
    <div class="modal-content">
      <div class="card card-signup card-plain">
        <div class="modal-header">
          <div class="card-header card-header-rose text-center">
            <button type="button" class="close" on:click={handleClose} aria-hidden="true">
              <i class="material-icons">clear</i>
            </button>
            <h4 class="card-title">Kontaktdaten</h4>
            <div class="social-line" />
          </div>
        </div>
        <div class="modal-body">
          {#if !wasSend}
            <form class="form" method="" action="">
              <p class="description text-center">Melden Sie sich bei uns,<br /> dann melden wir uns bei Ihnen.</p>
              <div class="card-body">
                <div class="form-group bmd-form-group w-100">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="material-icons">face</i>
                      </div>
                    </div>
                    <input bind:value={name} type="text" class="form-control" placeholder="Name (optional)" />
                  </div>
                </div>
                <div class="form-group bmd-form-group w-100">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="material-icons">email</i>
                      </div>
                    </div>
                    <input
                      bind:value={email}
                      type="text"
                      class={`form-control ${(noEmailAlert && 'noEmail') || ''}`}
                      placeholder="*E-Mail-Adresse"
                    />
                  </div>
                </div>
              </div>
            </form>
          {:else if success === true}
            <i class="material-icons icon check-icon">check_circle</i>
            <p class="description text-center">Vielen Dank, wir melden uns.</p>
          {:else if success === false}
            <i class="material-icons icon alert-icon">report_problem</i>
            <p class="description text-center">
              Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an <a href="mailto:it@equeo.de">it@equeo.de</a>.
            </p>
            <p class="description text-center">Fehler: {error}</p>
          {:else}
            <i class="material-icons icon loading"> autorenew </i>
            <p class="description text-center">Einen Moment bitte, Ihre Anfrage wird bearbeitet.</p>
          {/if}
        </div>
        {#if !wasSend}
          <div class="modal-footer justify-content-center">
            <span on:click={handleSend} class="btn btn-primary btn-link btn-wd btn-lg">Abschicken</span>
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>

<style>
  .modal {
    display: unset;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .icon {
    width: 100%;
    text-align: center;
    font-size: 10em;
  }

  .check-icon {
    color: green;
  }

  .alert-icon {
    color: orange;
  }

  @keyframes anim {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .loading {
    animation: anim 2s linear forwards infinite;
  }

  .noEmail::placeholder {
    color: red;
  }
</style>